export const blockIconsTextformattingSpaceDashboardNew = (
	<span className='material-symbols-outlined'>space_dashboard</span>
);
